export const NOTIFICATION_TYPE_SUCCESS = 'success'
export const NOTIFICATION_TYPE_ERROR = 'error'
export const NOTIFICATION_TYPE_WARNING = 'warning'
export const NOTIFICATION_TYPE_INFO = 'info'

// notification ids
export const NOTIFICATION_TZ_CHANGE_DETECTED = 'NOTIFICATION_TZ_CHANGE_DETECTED'
export const NOTIFICATION_TZ_CHANGE_APPROVED = 'NOTIFICATION_TZ_CHANGE_APPROVED'

export const NOTIFICATION_LAST_RELEASE_DETECTED = 'NOTIFICATION_LAST_RELEASE_DETECTED'
